module.exports = __webpack_public_path__ + "img/purple-3-oval-striped.1b69e8a7.svg";